module.exports = __webpack_public_path__ + "img/bpm-04.1c39b99c.jpg";